// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"button-meeting-add_btnGroup__3VnIt","popper":"button-meeting-add_popper__2XOh5","avatar":"button-meeting-add_avatar__345B2"};